export default "__VITE_ASSET__WUhMtBlq__"